import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ICustomerDetailsPage } from '@nx-ng/types';
import { CustomerStoreActions } from '../actions';
import * as CustomerStoreSelectors from '../selectors';

@Injectable({ providedIn: 'root' })
export class CustomerStoreFacade {
  customerLoaded$ = this.store.select(
    CustomerStoreSelectors.selectCustomerLoadedState
  );

  previousApplicantsLoaded = this.store.select(
    CustomerStoreSelectors.selectPreviousApplicantsLoadedState
  );

  isCustomerDetailsLoading$ = this.store.select(
    CustomerStoreSelectors.selectCustomerDetailsLoading
  );

  existingCustomer$ = this.store.select(
    CustomerStoreSelectors.selectCustomerDetails
  );

  allCustomerDetails$ = this.store.select(
    CustomerStoreSelectors.selectCustomerPageDetails
  );

  customerId$ = this.store.select(CustomerStoreSelectors.selectCustomerId);

  previousApplicants$ = this.store.select(
    CustomerStoreSelectors.selectPreviousApplicants
  );

  hasPreviousApplicants$ = this.store.select(
    CustomerStoreSelectors.selectHasPreviousApplicants
  );

  customerEmail$ = this.store.select(
    CustomerStoreSelectors.selectCustomerEmail
  );

  customerHasMissingFields$ = this.store.select(
    CustomerStoreSelectors.selectCustomerHasMissingFields
  );

  constructor(private readonly store: Store) {}

  loadCustomer() {
    this.store.dispatch(CustomerStoreActions.loadDataAccessCustomerDetails());
  }

  loadExistingSwiftCards({
    applicantId,
    ticketID,
  }: {
    applicantId: string;
    ticketID: number;
  }) {
    this.store.dispatch(
      CustomerStoreActions.customerAPI_GetApplicantSwiftCards({
        applicantCustomerID: applicantId,
        ticketID,
      })
    );
  }

  saveCustomer(customerFormData: ICustomerDetailsPage) {
    this.store.dispatch(
      CustomerStoreActions.saveCustomerFromAccountPage({
        customerFormData,
      })
    );
  }

  verifySwiftCard(basketItemId: number, quantityIndex: number, cardNumber: string) {
    this.store.dispatch(
      CustomerStoreActions.customerAPI_verifySwiftCard({
        cardNumber,
        basketItemId,
        quantityIndex
      })
    );
  }

  verifyMTicket(basketItemId: number, quantityIndex: number, emailAddress: string) {
    this.store.dispatch(
      CustomerStoreActions.customerAPI_verifyMobileApp({
        emailAddress,
        basketItemId,
        quantityIndex
      })
    );
  }
}
